import { CheckCircleTwoTone } from '@ant-design/icons';
import { Button, Popconfirm } from 'antd';
import { PopconfirmProps } from 'antd/lib';

export const SaveAction = ({ onConfirm, loading, disabled }: Omit<PopconfirmProps, 'title'> & { loading?: boolean }) => (
  <Popconfirm
    title='Sure to save?'
    disabled={disabled}
    onConfirm={onConfirm}
  >
    <Button
      type='text'
      size='small'
      loading={loading}
      className='mr-1'
      icon={(
        <CheckCircleTwoTone
          title='Save'
          twoToneColor={disabled ? '#bfbfbf' : '#52c41a'}
        />
      )}
    />
  </Popconfirm>
);
